/**************************************************
 * Nombre:
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {ButtonBase, Grid, Typography, useMediaQuery} from "@mui/material";
import {useResponsive} from "../../../Modulo_Responsive/Hooks/useResponsive";
import {theme} from "../../../Tema";
import {irUrl} from "../../../Utilidades/irUrl";


const Banner_Portada_Home = ({item}) => {
    const {sCell} = useResponsive()

    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}}
               justifyContent={'flex-start'}
               alignItems={'center'}
               spacing={1.5}
               sx={{
                   backgroundImage: `linear-gradient(70deg, ${theme.palette.primary.main} 40%, transparent 80%), url(${item.img})`,
                   backgroundSize: "cover",
                   color: 'white',
                   borderRadius: 4,
                   padding: {xs: 6, sm: 9, md: 9},
                   boxShadow: 2
               }}>
            <Grid container
                   justifyContent={"flex-start"}
                   alignItems={'center'}
                   size={{xs: 12, sm: 12, md: 8}}
                   sx={{width: '100%'}}>
                <Typography
                    sx={{
                        fontSize: {xs: 32, md: 32},
                        fontWeight: 900,
                        textAlign: {xs: 'center', sm: 'left', md: 'left'},
                        width: "100%",
                        lineHeight: 1.1
                    }}>
                    {item.titulo}
                </Typography>
                <Typography component="p"
                            sx={{textAlign: {xs: 'center', sm: 'left', md: 'left'}, fontSize: 16}}>
                    {item.parrafo}
                </Typography>
                <Grid
                    container
                    size={12}
                    justifyContent={{xs: "center", sm: "flex-start"}}
                    alignItems={'flex-start'}
                    sx={{
                        marginTop: {xs: 2, md: 2},
                        textAlign: {xs: 'center', sm: 'left', md: 'left'},
                        width: "100%"
                    }}
                >
                    <ButtonBase
                        onClick={() => item.link && irUrl(item.link)}
                        color={'white'}
                        sx={{

                            color: theme.palette.primary.main,
                            background: 'white',
                            borderRadius: 8,
                            paddingX: 4,
                            paddingY: 1,

                        }}>
                        <Typography sx={{fontWeight: 700, fontSize: 14}}>
                            {item.boton}
                        </Typography>
                    </ButtonBase>
                </Grid>
            </Grid>
            <Grid container size={{xs: 12, sm: 12, md: 4}}>

            </Grid>


        </Grid>
    )
}
export default Banner_Portada_Home